import type Phaser from 'phaser';
import type { AsteroidVariantConfig } from '../config/asteroidVariants';

export const ASTEROID_RENDER_REVISION = 3;
export const ASTEROID_RENDER_KEY = `asteroid-graphics-v${ASTEROID_RENDER_REVISION}`;

export function drawAsteroidGraphics(
  graphics: Phaser.GameObjects.Graphics,
  variant: AsteroidVariantConfig,
): void {
  const points = variant.points.map(([x, y]) => ({ x: x * variant.scale, y: y * variant.scale }));
  graphics.clear();
  graphics.fillStyle(variant.colors.shadow);
  graphics.beginPath();
  graphics.moveTo(points[0]!.x, points[0]!.y);
  points.slice(1).forEach((point) => graphics.lineTo(point.x, point.y));
  graphics.closePath().fillPath();
  const inset = points.map((point) => ({ x: point.x * 0.72 - 2, y: point.y * 0.72 - 2 }));
  graphics.fillStyle(variant.colors.mid);
  graphics.beginPath();
  graphics.moveTo(inset[0]!.x, inset[0]!.y);
  inset.slice(1).forEach((point) => graphics.lineTo(point.x, point.y));
  graphics.closePath().fillPath();
  graphics.fillStyle(variant.colors.light);
  graphics.fillTriangle(
    points[0]!.x * 0.65,
    points[0]!.y * 0.65,
    points[1]!.x * 0.62,
    points[1]!.y * 0.62,
    0,
    -2,
  );
  const hash = variant.id.length;
  graphics.fillStyle(variant.colors.shadow);
  graphics.fillRect(-3 - (hash % 4), 1, 5 + (hash % 3), 4);
  graphics.fillStyle(variant.colors.accent);
  graphics.fillRect(2, -6 + (hash % 3), 3, 2);
}
